import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export function getBilling(pageNo, sortField, sortBy) {
  return axios.get(
    `${BASE_URL}/api/billing/invoices`
  );
}

export function getInvoiceDetails(invoiceId) {
  // console.log("API URL:", `${BASE_URL}/api/billing/invoice/${invoiceId}`);
  return axios.get(
    `${BASE_URL}/api/billing/invoice/${invoiceId}`
  );
}

export function getClientDetails(clientId) {
  return axios.get(
    `${BASE_URL}/api/billing/client-details`
  );
}

export function getEstimatedBilling() {
  return axios.get(
    `${BASE_URL}/api/billing/estimated`
  );
}

export const SET_CLIENT_BALANCE = 'SET_CLIENT_BALANCE';
export const setClientBalance = (balance) => ({
  type: SET_CLIENT_BALANCE,
  payload: balance,
});

export const fetchClientBalance = () => async (dispatch, getState) => {
  const { clientBalance } = getState().billingReducer;

  if (clientBalance !== null) return;

  try {
    const response = await getClientDetails();
    if (response?.data?.header?.code === 200) {
      dispatch(setClientBalance(response.data.body.credit));
    }
  } catch (e) {}
};
